import { StarIcon } from "@heroicons/react/24/solid";
import { FileImage, FileVideo, ExternalLink } from "lucide-react";
import React from "react";
import Avatar from "shared/Avatar/Avatar";

const DEMO_DATA = {
  name: "Cody Fisher",
  date: "May 20, 2021",
  comment:
    "There's no stopping the tech giant. Apple now opens its 100th store in China.There's no stopping the tech giant.",
  starPoint: 5,
  media: "https://example.com/sample-media.jpg",
};

const CommentListing = ({
  className = "",
  data = DEMO_DATA,
  hasListingTitle,
}) => {
  const isImage = data.media?.match(/\.(jpg|jpeg|png|gif|webp)$/i);
  const isVideo = data.media?.match(/\.(mp4|webm|ogg|mov)$/i);

  const MediaIcon = () => {
    if (isImage) return <FileImage className="w-4 h-4" />;
    if (isVideo) return <FileVideo className="w-4 h-4" />;
    return <ExternalLink className="w-4 h-4" />;
  };

  return (
    <div
      className={`nc-CommentListing flex space-x-4 ${className}`}
      data-nc-id="CommentListing"
    >
      <div className="pt-0.5">
        <Avatar
          sizeClass="h-10 w-10 text-lg"
          radius="rounded-full"
          userName={data.name}
          imgUrl={data.avatar}
        />
      </div>
      <div className="flex-grow">
        <div className="flex justify-between space-x-3">
          <div className="flex flex-col">
            <div className="text-sm font-semibold">
              <span>{data.name}</span>
              {hasListingTitle && (
                <>
                  <span className="text-neutral-500 dark:text-neutral-400 font-normal">
                    {` review in `}
                  </span>
                  <a href="/">The Lounge & Bar</a>
                </>
              )}
            </div>
            <span className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">
              {data.date}
            </span>
          </div>
          <div className="flex text-yellow-500">
            <StarIcon className="w-4 h-4" />
            <StarIcon className="w-4 h-4" />
            <StarIcon className="w-4 h-4" />
            <StarIcon className="w-4 h-4" />
            <StarIcon className="w-4 h-4" />
          </div>
        </div>
        <span className="block mt-3 text-neutral-6000 dark:text-neutral-300">
          {data.comment}
        </span>
        {data.media && (
          <a
            href={data.media}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center mt-3 space-x-2 text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 group"
          >
            <div className="relative overflow-hidden rounded-lg w-16 h-16 bg-neutral-100 dark:bg-neutral-800">
              {isImage ? (
                <img
                  src={data.media}
                  alt="Comment media"
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <MediaIcon />
                </div>
              )}
            </div>
            <span className="flex items-center space-x-1">
              <span>View attachment</span>
              <ExternalLink className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
            </span>
          </a>
        )}
      </div>
    </div>
  );
};

export default CommentListing;
